export * from './feature-details.component';
export * from './feature-details-binding.directive';
